import React, {useState,useEffect} from 'react';
import axios from 'axios';
import './FeedbackContent.css';

function FeedbackContent() {                  
    const [feedback, setFeedback] = useState([]);
    
    const fetchData = async () => {
        try {
                let response = await axios({
                    method: 'get',
                    url: process.env.REACT_APP_FEEDBACK_URL,                    
                })
            setFeedback(response.data);
        } catch(error) {
            console.log(error);
        }        
    }
    
    useEffect(() => {
        fetchData();
    },[]);    

    return (
        <div className="feedback-container">            
            {
                feedback.length > 0 && feedback.map((data, index) => {
                    return <div className="feedback-data">
                                <div className="feedback-data-header">
                                    <h5 className='feedback-header-text'>{data.user}</h5>
                                </div>
                                <div className="feedback-data-body">                    
                                    <p className="feedback-data-text"><span className='feedback-text-heading'>Answer1 </span> &nbsp; {data.feedback.answer1}</p>
                                    <p className="feedback-data-text"><span className='feedback-text-heading'>Answer2 </span> &nbsp; {data.feedback.answer2}</p> 
                                    <p className="feedback-data-text"><span className='feedback-text-heading'>Answer3 </span> &nbsp; {data.feedback.answer3}</p>
                                    <p className="feedback-data-text"><span className='feedback-text-heading'>Comment </span> &nbsp; {data.feedback.comment}</p>                                    
                                </div>
                            </div>
                })                 
            }     
            {
                feedback.length === 0 && (<h3>Feedback Not Found</h3>)
            }            
        </div>
    )
}

export default FeedbackContent;